import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import {
  MANAGE_SUBS_REMOVE_CUSTOMERS_BEGIN,
  MANAGE_SUBS_REMOVE_CUSTOMERS_SUCCESS,
  MANAGE_SUBS_REMOVE_CUSTOMERS_FAILURE,
  MANAGE_SUBS_REMOVE_CUSTOMERS_DISMISS_ERROR,
} from './constants';

export function removeCustomers(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_REMOVE_CUSTOMERS_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.delete(`${API_REQUEST_URL}/removeCustomers`, {
        headers: {
          'Authorization': token,
        },
        data: args,
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_REMOVE_CUSTOMERS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_REMOVE_CUSTOMERS_FAILURE,
            data: { error: errorMsg },
          });
          reject(errorMsg);
        },
      );
    });

    return promise;
  };
}

export function dismissRemoveCustomersError() {
  return {
    type: MANAGE_SUBS_REMOVE_CUSTOMERS_DISMISS_ERROR,
  };
}

export function useRemoveCustomers() {
  const dispatch = useDispatch();

  const { removeCustomersPending, removeCustomersError } = useSelector(
    state => ({
      removeCustomersPending: state.manageSubs.removeCustomersPending,
      removeCustomersError: state.manageSubs.removeCustomersError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(removeCustomers(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissRemoveCustomersError());
  }, [dispatch]);

  return {
    removeCustomers: boundAction,
    removeCustomersPending,
    removeCustomersError,
    dismissRemoveCustomersError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_REMOVE_CUSTOMERS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        removeCustomersPending: true,
        removeCustomersError: null,
      };

    case MANAGE_SUBS_REMOVE_CUSTOMERS_SUCCESS:
      // The request is success
      return {
        ...state,
        removeCustomersPending: false,
        removeCustomersError: null,
      };

    case MANAGE_SUBS_REMOVE_CUSTOMERS_FAILURE:
      // The request is failed
      return {
        ...state,
        removeCustomersPending: false,
        removeCustomersError: action.data.error,
      };

    case MANAGE_SUBS_REMOVE_CUSTOMERS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        removeCustomersError: null,
      };

    default:
      return state;
  }
}
